export default __webpack_public_path__ + "static/media/Bildschirmfoto 2022-01-18 um 10.49.25.8a9d3c98.png";